"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./Tab.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tab = /*#__PURE__*/function (_Component) {
  function Tab(props) {
    var _this;
    _classCallCheck(this, Tab);
    _this = _callSuper(this, Tab, [props]);
    _this.state = {
      activeIndex: _this.props.defaultActiveIndex
    };
    return _this;
  }
  _inherits(Tab, _Component);
  return _createClass(Tab, [{
    key: "handleTabChange",
    value: function handleTabChange(e, index) {
      e.preventDefault();
      this.props.onTabChange(index);
      this.setState({
        activeIndex: index
      });
    }
  }, {
    key: "getClasses",
    value: function getClasses() {
      return (0, _cssClassesHelper.getBEMClasses)(['ap-tab', this.props.customClass]);
    }
  }, {
    key: "_renderMenu",
    value: function _renderMenu() {
      var classes = this.getClasses();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes('menu', this.props.classModifiers)
      }, this._renderMenuItems());
    }
  }, {
    key: "_renderMenuItems",
    value: function _renderMenuItems() {
      var _this2 = this;
      var _this$props = this.props,
        panes = _this$props.panes,
        classModifiers = _this$props.classModifiers;
      var classes = this.getClasses();
      return panes.map(function (pane, index) {
        var activeClassName = _this2.state.activeIndex === index ? classes('menu-item', ['active'].concat(classModifiers.map(function (i) {
          return "".concat(i, "-active");
        }))) : '';
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])(activeClassName, classes('menu-item', classModifiers)),
          onClick: function onClick(e) {
            if (pane.onSelect) {
              pane.onSelect();
            }
            _this2.handleTabChange(e, index);
          },
          key: pane.menuItem,
          "data-test": pane.menuItem
        }, pane.menuItem);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        panes = _this$props2.panes,
        classModifiers = _this$props2.classModifiers;
      var currentPane = panes[this.state.activeIndex];
      var classes = this.getClasses();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classes('tab', classModifiers))
      }, this._renderMenu(), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes('tab-content', classModifiers)
      }, currentPane.render()));
    }
  }]);
}(_react.Component);
_defineProperty(Tab, "propTypes", {
  onTabChange: _propTypes["default"].func,
  panes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    menuItem: _propTypes["default"].string.isRequired,
    render: _propTypes["default"].func.isRequired,
    onSelect: _propTypes["default"].func
  })).isRequired,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  defaultActiveIndex: _propTypes["default"].number
});
_defineProperty(Tab, "defaultProps", {
  customClass: 'custom-tab',
  classModifiers: [],
  defaultActiveIndex: 0,
  onTabChange: function onTabChange() {}
});
var _default = exports["default"] = Tab;